module.exports = __webpack_public_path__ + "static/media/react.692adb35.png";